import apiPdca from '../../../helpers/apiPdca'
import apiCompetitorGap from '../../../helpers/apiCompetitorGap'

import { loaded, loading } from '../../../layout/redux/layoutActions'

export const COMPETITOR_GAP_SET_CONTEXTO = 'COMPETITOR_GAP_SET_CONTEXTO'
export const COMPETITOR_GAP_SET_CONTEXTO_LOADING = 'COMPETITOR_GAP_SET_CONTEXTO_LOADING'
export const COMPETITOR_GAP_SET_CONTEXTO_ERRO = 'COMPETITOR_GAP_SET_CONTEXTO_ERRO'

export const COMPETITOR_GAP_SET_GAPS = 'COMPETITOR_GAP_SET_GAPS'
export const COMPETITOR_GAP_SET_LISTA_LOADING = 'COMPETITOR_GAP_SET_LISTA_LOADING'
export const COMPETITOR_GAP_SET_LISTA_ERRO = 'COMPETITOR_GAP_SET_LISTA_ERRO'

export const COMPETITOR_GAP_SET_DETALHE = 'COMPETITOR_GAP_SET_DETALHE'
export const COMPETITOR_GAP_SET_DETALHE_LOADING = 'COMPETITOR_GAP_SET_DETALHE_LOADING'
export const COMPETITOR_GAP_SET_DETALHE_ERRO = 'COMPETITOR_GAP_SET_DETALHE_ERRO'

export const COMPETITOR_GAP_SET_FILTRO_STATUS = 'COMPETITOR_GAP_SET_FILTRO_STATUS'
export const COMPETITOR_GAP_LIMPAR_DETALHE = 'COMPETITOR_GAP_LIMPAR_DETALHE'
export const COMPETITOR_GAP_RESET = 'COMPETITOR_GAP_RESET'

export const setCompetitorGapContexto = payload => ({
  type: COMPETITOR_GAP_SET_CONTEXTO,
  payload
})

export const setCompetitorGapContextoLoading = payload => ({
  type: COMPETITOR_GAP_SET_CONTEXTO_LOADING,
  payload
})

export const setCompetitorGapContextoErro = payload => ({
  type: COMPETITOR_GAP_SET_CONTEXTO_ERRO,
  payload
})

export const setCompetitorGapGaps = payload => ({
  type: COMPETITOR_GAP_SET_GAPS,
  payload
})

export const setCompetitorGapListaLoading = payload => ({
  type: COMPETITOR_GAP_SET_LISTA_LOADING,
  payload
})

export const setCompetitorGapListaErro = payload => ({
  type: COMPETITOR_GAP_SET_LISTA_ERRO,
  payload
})

export const setCompetitorGapDetalhe = payload => ({
  type: COMPETITOR_GAP_SET_DETALHE,
  payload
})

export const setCompetitorGapDetalheLoading = payload => ({
  type: COMPETITOR_GAP_SET_DETALHE_LOADING,
  payload
})

export const setCompetitorGapDetalheErro = payload => ({
  type: COMPETITOR_GAP_SET_DETALHE_ERRO,
  payload
})

export const setCompetitorGapFiltroStatus = payload => ({
  type: COMPETITOR_GAP_SET_FILTRO_STATUS,
  payload
})

export const limparCompetitorGapDetalhe = () => ({
  type: COMPETITOR_GAP_LIMPAR_DETALHE
})

export const resetCompetitorGap = () => ({
  type: COMPETITOR_GAP_RESET
})

const normalizarRespostaVerificarEmpresaPdca = (responseData, projetoId) => {
  const empresaId = Number(responseData?.empresaid || 0)

  return {
    projetoId: Number(responseData?.projetoid || projetoId),
    empresaPdcaExiste: empresaId > 0,
    empresaPdcaId: empresaId,
    empresaPdcaNome: responseData?.empresadescricao || '',
    projetoNome: responseData?.projetodescricao || ''
  }
}

export const buscarContextoCompetitorGap = projetoId => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setCompetitorGapContextoLoading(true))
      dispatch(setCompetitorGapContextoErro(null))

      const response = await apiPdca.get(`/Pdca/VerificarExisteEmpresaPdca?projetoId=${projetoId}`)
      const contexto = normalizarRespostaVerificarEmpresaPdca(response.data, projetoId)

      dispatch(setCompetitorGapContexto(contexto))

      return {
        ok: true,
        contexto
      }
    } catch (error) {
      console.error('Erro ao buscar contexto do Competitor Gap:', error)

      dispatch(setCompetitorGapContextoErro(error?.response?.data || error))

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setCompetitorGapContextoLoading(false))
      dispatch(loaded())
    }
  }
}

/*
export const listarCompetitorGaps = ({ projetoId, statusId }) => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setCompetitorGapListaLoading(true))
      dispatch(setCompetitorGapListaErro(null))
      dispatch(setCompetitorGapFiltroStatus(statusId))

      const response = await apiCompetitorGap.post('/CompetitorGap/List', {
        projetoId,
        statusId
      })

      const gaps = response.data?.gaps || []

      dispatch(setCompetitorGapGaps(gaps))

      return {
        ok: true,
        gaps
      }
    } catch (error) {
      console.error('Erro ao listar Competitor Gaps:', error)

      dispatch(setCompetitorGapListaErro(error?.response?.data || error))

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setCompetitorGapListaLoading(false))
      dispatch(loaded())
    }
  }
}
*/


export const listarCompetitorGaps = ({ projetoId, statusId }) => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setCompetitorGapListaLoading(true))
      dispatch(setCompetitorGapListaErro(null))
      dispatch(setCompetitorGapFiltroStatus(statusId))

      const body = {
        projetoId,
        statusId
      }

      console.log('CompetitorGap/List - body enviado:', body)

      const response = await apiCompetitorGap.post('CompetitorGap/List', body)

      console.log('CompetitorGap/List - response:', response)

      const gaps = response.data?.gaps || []

      dispatch(setCompetitorGapGaps(gaps))

      return {
        ok: true,
        gaps
      }
    } catch (error) {
      //console.error('Erro ao listar Competitor Gaps - objeto completo:', error)
      //console.error('Erro ao listar Competitor Gaps - status:', error?.response?.status)
      //console.error('Erro ao listar Competitor Gaps - data:', error?.response?.data)
      //console.error('Erro ao listar Competitor Gaps - headers:', error?.response?.headers)
      //console.error('Erro ao listar Competitor Gaps - message:', error?.message)

      dispatch(setCompetitorGapListaErro(error?.response?.data || error))

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setCompetitorGapListaLoading(false))
      dispatch(loaded())
    }
  }
}




export const buscarCompetitorGapDetalhe = gapId => {
  return async dispatch => {
    try {
      dispatch(loading())
      dispatch(setCompetitorGapDetalheLoading(true))
      dispatch(setCompetitorGapDetalheErro(null))
      dispatch(limparCompetitorGapDetalhe())

      const response = await apiCompetitorGap.post('CompetitorGap/Detail', {
        gapId
      })

      dispatch(setCompetitorGapDetalhe(response.data))

      return {
        ok: true,
        detalhe: response.data
      }
    } catch (error) {
      console.error('Erro ao buscar detalhe do Competitor Gap:', error)

      dispatch(setCompetitorGapDetalheErro(error?.response?.data || error))

      return {
        ok: false,
        erro: error?.response?.data || error
      }
    } finally {
      dispatch(setCompetitorGapDetalheLoading(false))
      dispatch(loaded())
    }
  }
}